import * as mfaApi from '../services/api/mfa';
import {attach} from "../services/api/sso";

export const SET_AUTH_METHODS = 'SET_AUTH_METHODS';
export const SET_AUTH_ERRORS = 'SET_AUTH_ERRORS';
export const SET_AUTH_SUCCESS_TRUE = 'SET_AUTH_SUCCESS_TRUE';
export const SET_AUTH_SUCCESS_FALSE ='SET_AUTH_SUCCESS_FALSE';
export const RESET_AUTH_ERRORS = 'RESET_AUTH_ERRORS';
export const SET_TOKEN_EXPIRED = 'SET_TOKEN_EXPIRED';

export function getUserAuthMethods(token){
    return dispatch => {
        const success = response => {
            dispatch(setAuthMethods(response.payload.auth_methods));
        }
        const fail = response => dispatch(setAuthErrors(response.payload));

        return mfaApi
            .getUserAutMethods(token)
            .then(success, fail);
    }
}

export function sendEmailCode(token){
    return dispatch => {
        const fail = response => dispatch(setAuthErrors(response.payload));

        return mfaApi
            .sendEmailCode(token)
            .then(null, fail);
    }
}

function setAuthMethods(authMethods){
    return {
        type: SET_AUTH_METHODS,
        authMethods
    }
}

export function verifyCode(verify, values, serviceId, token) {
    const verifyParams = {
        ...values,
        service_id: serviceId,
        token: token
    }

    return dispatch => {
        const success = () => dispatch(setAuthSuccessTrue());
        const fail = errors => {
            dispatch(setAuthErrors(errors.payload));
            if('token_expired' in errors.payload) {
                dispatch(setTokenExpired());
            }
        };

        return attach()
            .then(() => verify(verifyParams))
            .then(success, fail);
    }
}

export function verifyEmailCode(values, serviceId, token) {
    return verifyCode(mfaApi.verifyEmailCode, ...arguments);
}

export function verifyAppCode(values, serviceId, token) {
    return verifyCode(mfaApi.verifyAppCode, ...arguments);
}

export function verifySmsCode(values, serviceId, token){
    return verifyCode(mfaApi.verifySmsCode, ...arguments);
}

export function sendSmsCode(token){
    return dispatch => {
        const fail = response => dispatch(setAuthErrors(response.payload));

        return mfaApi.sendSmsCode(token)
            .then(null, fail);
    }
}

function setAuthErrors(errors){
    return {
        type: SET_AUTH_ERRORS,
        errors
    }
}

export function resetAuthErrors(){
    return {
        type: RESET_AUTH_ERRORS
    }
}

function setAuthSuccessTrue(){
    return {
        type: SET_AUTH_SUCCESS_TRUE
    }
}

function setAuthSuccessFalse(){
    return {
        type: SET_AUTH_SUCCESS_FALSE
    }
}

function setTokenExpired(){
    return {
        type: SET_TOKEN_EXPIRED
    }
}